import {
  checkPWAInstallStatus,
  checkHasChromeExtension,
  isChromeWithoutExclusions,
  checkWebPlatformDevice,
} from 'shared/infra/browser-detection';
import { chromeBrowserBannerAnalytic } from './analytics';

import type { DefaultServicesParams } from '../domain';

async function setup(params: Pick<DefaultServicesParams, 'partnerId'>) {
  const { partnerId } = params;
  const platformDevice = checkWebPlatformDevice();
  const isMobileDevice =
    platformDevice === 'mobile' || platformDevice === 'possibly_mobile';
  const hasChromeExtension = await checkHasChromeExtension();
  const pwaInstallStatus = await checkPWAInstallStatus();
  const isChromeBrowser = isChromeWithoutExclusions();
  chromeBrowserBannerAnalytic.logHasChromeExtension({
    partnerId,
    pwaInstallStatus,
    isInstalled: hasChromeExtension,
  });
  console.info('pwaInstallStatus:', pwaInstallStatus);
  return {
    isMobileDevice,
    isChromeBrowser,
    hasChromeExtension,
  };
}

function goToInstall(params: DefaultServicesParams) {
  const { partnerId, missingContent } = params;
  const URL_TO_EXTENSION = process.env.REACT_APP_CHROME_EXTENSION_URL || '';
  if (missingContent === 'BROWSER') {
    window.open('https://www.google.com/intl/es-419/chrome/', '_blank');
  }
  if (missingContent === 'EXTENSION' && URL_TO_EXTENSION) {
    window.open(URL_TO_EXTENSION, '_blank');
  }
  chromeBrowserBannerAnalytic.logEventChrome({
    partnerId,
    missingContent,
    userAction: 'INSTALL',
  });
}

function closeBanner(params: DefaultServicesParams) {
  const { partnerId, missingContent } = params;
  chromeBrowserBannerAnalytic.logEventChrome({
    partnerId,
    missingContent,
    userAction: 'CLOSED',
  });
}

export const chromeBrowserBannerService = {
  setup,
  goToInstall,
  closeBanner,
} as const;
